import Popup from './popUp.js';

var returnPointTypePopUp = (function (data) {
  if (!document.getElementById('return-point-popup')) {
    return;
  }

  // window.mobileNav = Popup.init('return-point-popup');
  var returnPointTypePopUp = Popup.init('return-point-popup');

  var $returnPointTypePopUpTigger = $('.js-return-point-popup-trigger');
  var $body = $('body');

  returnPointTypePopUp.on('show', function (dialogEl, triggerEl) {

    $body.addClass('js-return-point-popup-active');
    $returnPointTypePopUpTigger.addClass('is-active');
    $(dialogEl).find('.c-button--hamburger').addClass('is-active');

  });

  returnPointTypePopUp.on('hide', function (dialogEl, triggerEl) {

    $body.removeClass('js-return-point-popup-active');
    $returnPointTypePopUpTigger.removeClass('is-active');
    $(dialogEl).find('.c-button--hamburger').removeClass('is-active');

  });

  $returnPointTypePopUpTigger.on('click', function (e) {

    e.preventDefault();
    $('.c-return-point-pop-up h2, .c-return-point-pop-up .c-return-point-type--feature-image, .c-return-point-pop-up .c-return-point-type--copy').html('');
    for(var i =0; i< data.length; i++){
      if($(this).attr('id') == data[i].css_id_selector){
        $('.c-return-point-pop-up h2').append(data[i].title);
        $('.c-return-point-pop-up .c-return-point-type--feature-image').append("<img src='"+data[i].image+"'>");
        $('.c-return-point-pop-up .c-return-point-type--copy').append(data[i].content);
      }
    }

    if ($returnPointTypePopUpTigger.hasClass('is-active')) {
      returnPointTypePopUp.hide();
    } else {
      returnPointTypePopUp.show();
    }
  });
});

export default returnPointTypePopUp;



// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/returnPointTypePopUp.js